// extracted by mini-css-extract-plugin
export default {"form-error":"FormError_form-error__PFzQL"};